import { render, staticRenderFns } from "./form-uk.vue?vue&type=template&id=459c012a&scoped=true&"
import script from "./form-uk.vue?vue&type=script&lang=js&"
export * from "./form-uk.vue?vue&type=script&lang=js&"
import style0 from "./form-uk.vue?vue&type=style&index=0&id=459c012a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c012a",
  null
  
)

export default component.exports